<!DOCTYPE html>
<html lang="en">

    <head>

        <meta charset="utf-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
        <meta name="description" content="">
        <meta name="author" content="">

        <title>Dashboard</title>

    </head>

    <body id="page-top">

        <div>
            <app-ortho-menu [empresa]="appEmpresa" [diferencias]="appDiferencias" [acreditacion]="appAcreditacion"
                [enviarCaso]="appEnviarCaso"></app-ortho-menu>
            <app-ortho-home-image></app-ortho-home-image>
            <app-empresa #appEmpresa></app-empresa>
            <app-diferencias #appDiferencias></app-diferencias>
            <app-acreditacion #appAcreditacion></app-acreditacion>
            <app-enviar-caso #appEnviarCaso></app-enviar-caso>
            <app-footer-common></app-footer-common>
        </div>
    </body>

</html>